import { useEffect, useRef, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { observeOfferVisibility } from '@src/utils/observeOfferVisibility';
import { recordUpsellImpression } from '@src/utils/upsellImpressions';

/** Paid account upgrades have their own tier quote, independent of feature offers. */
export function AccountUpgradeView({ children, tier }: { children: ReactNode; tier: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const seen = useRef(new Set<string>());
  const { key, pathname } = useLocation();
  useEffect(() => {
    const identity = JSON.stringify([key, tier]);
    const button = ref.current?.closest<HTMLElement>('button, a');
    if (!button || seen.current.has(identity) || typeof IntersectionObserver === 'undefined') return;
    return observeOfferVisibility(button, () => {
      seen.current.add(identity);
      recordUpsellImpression(pathname, { feature: 'account', placement: 'account-tier-upgrade', targetTier: tier });
    }, 1);
  }, [key, pathname, tier]);
  return <span ref={ref}>{children}</span>;
}
